// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-iybr-wrapper {
  margin: 1.6rem 3.2rem 3.2rem;
  padding-bottom: 3.2rem;
}
.edit-iybr-wrapper .pui-breadcrumb-item--is-first .pui-breadcrumb-item__link {
  padding-left: 0;
}
.edit-iybr-wrapper .iybr-headline {
  margin-top: 1.6rem;
  margin-bottom: 2.4rem;
}
.edit-iybr-wrapper .form-spacer {
  width: 100%;
  margin-top: 1.6rem;
  margin-bottom: 1.6rem;
}
.edit-iybr-wrapper .action-row-p {
  padding-top: 2.4rem;
}
.edit-iybr-wrapper .flex-buttons {
  display: flex;
  gap: 0.8rem;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
